import { z } from 'zod'
import { emailSchema, passwordSchema, roleSchema } from './auth.js'

export const createUserSchema = z.object({
  email: emailSchema,
  name: z.string().trim().min(1, 'Name is required').max(120),
  role: roleSchema,
  password: passwordSchema,
})
export type CreateUserInput = z.infer<typeof createUserSchema>

export const updateUserSchema = z
  .object({
    name: z.string().trim().min(1).max(120).optional(),
    role: roleSchema.optional(),
    active: z.boolean().optional(),
  })
  .refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' })
export type UpdateUserInput = z.infer<typeof updateUserSchema>

export const resetUserPasswordSchema = z.object({
  newPassword: passwordSchema,
})
export type ResetUserPasswordInput = z.infer<typeof resetUserPasswordSchema>

export const listUsersQuerySchema = z.object({
  includeInactive: z
    .union([z.literal('true'), z.literal('false')])
    .optional()
    .transform((v) => v === 'true'),
})
export type ListUsersQuery = z.infer<typeof listUsersQuerySchema>
